import * as types from './mutation-types';
import api from '@/api';
import { removeLocalStorages } from '@/utils/auth';
import { setIcon } from '@/utils/dom';
import { STORAGE_LIST_BY_LOGIN } from '@/config/constant';
import store from '@/store';

let epidemicPrevention = [22614]; // 白名单后台的学校uid
/**
 * 用户名登录
 */
export const loginByUsername = function({ commit }, payload) {
	return new Promise((resolve, reject) => {
		api.user
			.loginByUsername(payload)
			.then(res => {
				if (res && res.status === 0) {
					let data = {
						token: res.data.IDToken,
						expires: res.data.expires_in
					};
					// 保存token的过期时间
					let expires = +new Date() + data.expires * 1000;
					localStorage.setItem('expires_time', expires);
					// 保存token
					localStorage.setItem('token', data.token);
					commit(types.LOGIN_BY_USERNAME, data);
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
};

/**
 * 旧版登录token
 */
export const loginTokenOld = function({ commit }, payload) {
	return new Promise((resolve, reject) => {
		api.user
			.loginTokenOld(payload)
			.then(res => {
				if (res && res.status === 0) {
					let { token } = res.data;
					localStorage.setItem('tokenOld', token);
					commit(types.LOGIN_TOKEN_OLD, { token });
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
};
/**
 * 获取用户基本信息
 */
export const getUserInfo = function({ commit }) {
	return new Promise((resolve, reject) => {
		api.user
			.getUserInfo()
			.then(res => {
				if (res && res.status === 0) {
					commit('SET_USER_INFO', { userInfo: res.data });
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
};
/**
 * 获取菜单分类项
 */
export const getMenuMapSort = function({ commit }) {
	return new Promise((resolve, reject) => {
		api.user
			.getMenuMapSort()
			.then(res => {
				if (res && res.status === 0) {
					let menuSort = res.data.list;
					let menuCategory = menuSort.length && menuSort[0]['key'];
					// console.log('ff', menuSort, menuCategory);
					commit(types.GET_MENU_MAP_SORT, { menuSort });
					commit(types.SET_MENU_CATEGORY_INDEX, menuCategory);
					menuCategory = window.sessionStorage.currentPage;
					resolve({ menuSort });
				} else {
					reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
};
/**
 * 获取菜单列表
 */
export const getMenuMap = function({ commit }, payload) {
	return new Promise((resolve, reject) => {
		api.user
			.getMenuMap(payload)
			.then(res => {
				let menu = res.data.menu;
				//  安全中心菜单并且是特定账号登录  添加白名单后台
				let currentUid = Number(store.state.user.userInfo.uid);
				if (
					Number(payload.menu_category) === 3 &&
					epidemicPrevention.includes(currentUid)
				) {
					menu.push({
						alias: 'safety-epidemic-prevention',
						icon: '',
						is_absolute_url: 0,
						is_display: 1,
						is_nav: 1,
						name: '白名单后台',
						parent_id: 0,
						path: '/school-safety/epidemic-prevention',
						sort: 0,
						role_id: 8,
						url: '/school-safety/epidemic-prevention'
					});
				}
				commit(types.GET_MENU_MAP, { menu });
				resolve({ menu });
			})
			.catch(err => {
				reject(err);
			});
	});
};

/**
 * logout
 */
export const logout = function({ commit }) {
	return new Promise(resolve => {
		removeLocalStorages(STORAGE_LIST_BY_LOGIN);
		commit(types.LOGOUT);
		resolve();
	});
};

/**
 * refresh token
 */
export const refreshToken = function({ commit }) {
	return new Promise((resolve, reject) => {
		api.user
			.refreshToken()
			.then(res => {
				if (res && res.status === 0) {
					let data = {
						token: res.data.IDToken,
						expires: res.data.expires_in
					};
					// 保存token的过期时间
					let expires = +new Date() + data.expires * 1000;
					localStorage.setItem('expires_time', expires);
					// 保存token
					localStorage.setItem('token', data.token);
					commit(types.LOGIN_BY_USERNAME, data);
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch(err => {
				reject(err);
			});
	});
};

/**
 * 获取菜单列表
 */
export const getLogoByDomain = function({ commit }, payload) {
	return new Promise((resolve, reject) => {
		api.user
			.getLogoByDamin(payload)
			.then(res => {
				let appInfo = {};
				if (res.status === 0) {
					appInfo = res.data;
					if (location.host === 'p.zhaonax.com') {
						appInfo.name = '管理系统';
					}
					// 江西农业工程职业学院
					if (location.host === 'jxnygc.x-bull.com') {
						appInfo.name = '校园管理平台';
						appInfo.logo =
							'https://xbullyun.oss-cn-shenzhen.aliyuncs.com/public/pcadmin/jxnygczyxy_logo.png';
						appInfo.favicon =
							'https://xbullyun.oss-cn-shenzhen.aliyuncs.com/public/pcadmin/jxnygczyxy_icon.png';
					}
					document.title = appInfo.name;
					setIcon(appInfo.favicon);
				}
				sessionStorage.setItem('appInfo', JSON.stringify(appInfo));
				commit(types.SET_APP_INFO, { appInfo });
				resolve({ appInfo });
			})
			.catch(err => {
				reject(err);
			});
	});
};
